export function isValidImageUrl(url: unknown): url is string {
  if (!url || typeof url !== "string") return false;
  const trimmed = url.trim();
  if (
    !trimmed ||
    trimmed === "null" ||
    trimmed === "undefined" ||
    trimmed === "#"
  ) {
    return false;
  }
  return true;
}

export function getFirstImageUrl(urls: unknown): string | null {
  if (Array.isArray(urls)) {
    const found = urls.find(isValidImageUrl);
    return found ?? null;
  }
  return isValidImageUrl(urls) ? urls : null;
}

export function uniqueExcerpt(
  name: string,
  description: string,
  maxLen = 80
): string {
  const plain = description?.replace(/<[^>]*>/g, "").trim() || "";
  if (!plain) return "";
  if (plain.toLowerCase() === name.trim().toLowerCase()) return "";
  return plain.length > maxLen ? `${plain.slice(0, maxLen)}…` : plain;
}
